<template>
  <router-view />
</template>

<script>
export default {
  name: "TreasuryMain",
};
</script>